import { loadable } from "@marta/utils";

export const LoginScreen = loadable(() => import("./login-screen"));
export const RegisterScreen = loadable(() => import("./register-screen"));
export const TokenResolverScreen = loadable(
  () => import("./token-resolver-screen"),
);
